import React from "react"
import Cookies from 'js-cookie'
import tinymce from 'tinymce/tinymce';
import EmailBuilderActions from "../EmailBuilder/actions/EmailBuilderActions"
import MessageBuilderActions from "../MessageBuilder/actions/MessageBuilderActions"
import 'tinymce/themes/silver/theme';
import 'tinymce/icons/default'
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/code';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/hr';


class RichTextEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      lastFocusedInput: null,
      cursorPosition: null,
      isFocused: false,
      namespace: this.props.namespace || "rte",
      active_tab: "merge_tags",
      if_select: I18n.t("lodging")
    }
  }

  componentDidMount() {
    this.initFocusWatcher();
    this.initCursorPositionWatcher();
    this.initTinyMCE();
    this.initEditorSizing();
  }

  componentDidUpdate(prevProps){
    if (this.props.className && this.props.className.includes('has-errors') && (!prevProps.className || !prevProps.className.includes('has-errors'))){
      $('.tox.tox-tinymce').addClass('has-errors');
    } else if (prevProps.className && prevProps.className.includes('has-errors') && (!this.props.className || !this.props.className.includes('has-errors'))) {
      $('.tox.tox-tinymce').removeClass('has-errors');
    };
  };

  initEditorSizing() {
    // if (this.props.auto_resize) {
    //   $(window).on('resize.RichTextEditor', function () {
    //     var window_height = $(window).height();
    //     var $editor = $('.tox-editor-container');
    //     if ($editor.length) {
    //       //
    //       // var editor_offset_top = $editor.offset().top;
    //       // $('.tox-tinymce').css({ height: (window_height - editor_offset_top - 74) + 'px' });
    //     }
    //   }).trigger('resize.RichTextEditor');
    // }
  }

  initFocusWatcher() {
    var self = this;
    $(document.body).on(`focus.${this.state.namespace}`, 'input', function (e) {
      self.setState({ lastFocusedInput: e.target });
    });
  }

  initCursorPositionWatcher() {
    var self = this;
    $(document.body).on(`keydown.${this.state.namespace} click.${this.state.namespace} focus.${this.state.namespace}`, 'input', function (e) {
      self.setState({ cursorPosition: self.getCursorPosition(e.target) });
    });
  }

  initTinyMCE() {
    var self = this;
    tinymce.baseURL = "tinymce/tinymce"
    tinymce.suffix = '.min';
    tinymce.init({
      toolbar: this.props.message ? 'maxmergetag' : `styleselect | fontselect | fontsizeselect | forecolor | bold italic underline | alignleft aligncenter alignright alignjustify | charmap hr | bullist numlist | table | link ${this.props.system_data ? '' : 'maximage'} maxmergetag surveylinks| undo redo | code`,
      plugins: 'paste image lists table code charmap hr link',
      selector: `.editor${this.state.namespace}`,
      menubar: false,
      statusbar: false,
      content_css: false,
      convert_urls: false,
      skin: false,
      height: self.props.height || 420,
      forced_root_block: false,
      invalid_elements : this.props.message ? 'div': '',
      init_instance_callback: function (editor) {
        if (typeof self.props.disableLoading === 'function') {
          self.props.disableLoading()
        }
        editor.on('Change', function (e) {
          if (typeof self.props.onChange === 'function') {
            self.props.onChange(tinymce.activeEditor.getContent());
          }
        });
        editor.on('Keypress', function (e) {
          if (e.keyCode == 13) {
            // ENTER pressed - prevent default so page doesn't scroll down
            e.preventDefault();
          }
          if (typeof self.props.onChange === 'function') {
            self.props.onChange(tinymce.activeEditor.getContent());
          }
        });
        editor.on('Focus', function (e) {
          self.setState({ isFocused: true });
        });
        editor.on('Blur', function (e) {
          self.setState({ isFocused: false });
        });

        if (self.props.initLoading) {
          self.props.initLoading()
        };
      },
      setup: function (editor) {
        editor.on('init', function(e) {
          if (self.props.onInit) {
            self.props.onInit();
          }
        });
        if (self.props.merge_tag_button) {
          self.addMaxMergeTagButton(editor);
        }

        if (self.props.image_button) {
          self.addMaxImageButton(editor);
        }

        // if (self.props.survey_links_button) {
        //   self.addSurveyLinksButton(editor);
        // }
      }
    });
  };

  render() {
    return (
      <div className={`editor${this.state.namespace}`}  dangerouslySetInnerHTML={{ __html: this.props.body }}></div>
    );
  }

  /**
  * Helper functions
  */

  addMaxImageButton(editor) {
    var self = this;
    if (editor.ui) {
      editor.ui.registry.addButton('maximage', {
        icon: 'image',
        tooltip: I18n.t('add_image'),
        disabled: false,
        onAction: function (_) {
          tinymce.activeEditor.windowManager.openUrl({
            title: I18n.t('add_image'),
            url: self.props.images_data_table_path,
            buttons: [
              {
                type: 'cancel',
                text: I18n.t('cancel')
              },
              {
                type: 'custom',
                text: I18n.t('add'),
                name: 'insert-images',
                primary: true,
                enabled: false,
              }
            ],
            onMessage: (dialogApi, details) => {
              $($('.tox-button', top[0].contentDocument)[2]).prop('disabled', !$('.checked', $('iframe')[1].contentDocument).length > 0);
            },
            onAction: (dialogApi, details) => {
              // This is a little weird, but works
              dialogApi.block("Loading...")
              if (details.name === 'insert-images') {
                var src
                var images = []
                var context = $('iframe')[1].contentDocument
                
                $('.checked', context).each(function () {
                  if ($(this).attr('original_url')) {
                    src = $(this).attr('original_url');
                  } else {
                    src = $(this).attr('src');
                  }

                  if (src) {
                    images.push(src);
                  }
                })
                
                window.insert_images(images);
                dialogApi.unblock();
              }
            }
          });
        },
        onSetup: function (buttonApi) {
          window.insert_images = function (images) {
            var ed = tinyMCE.activeEditor;

            ed.windowManager.close();
            images.map(function (src) { ed.execCommand('InsertImage', false, src)})
          };
          
          var editorEventCallback = function (eventApi) {
            buttonApi.setDisabled(eventApi.element.nodeName.toLowerCase() === 'time');
          };
          editor.on('NodeChange', editorEventCallback);
          /* onSetup should always return the unbind handlers */
          return function (buttonApi) {
            editor.off('NodeChange', editorEventCallback);
          };
        }
      });
    }
  }

  addMaxMergeTagButton(editor) {
    var self = this;
    if (editor.ui) {
      editor.ui.registry.addButton('maxmergetag', {
        icon: 'embed-page',
        tooltip: I18n.t('insert_merge_tag'),
        disabled: false,
        onAction: function mergeTagAction(_) {
          tinymce.activeEditor.windowManager.open({
            title: self.getMaxMergeTagTitle(),
            body: {
              type: 'panel',
              items: [
                {
                  type: 'htmlpanel',
                  html: self.getMaxMergeTagTemplate()
                }
              ]
            },
            buttons: [
              {
                type: 'cancel',
                text: 'OK'
              }
            ]
          });
          var button = this

          $(document.body).off(`click.mergetag`).on(`click.mergetag`, '.insert-merge-tag', function () {
            var $this = $(this);
            var textVariables = $this.parents('tr').find('td:first-child').html();
            
            if ($this[0].className.includes("example")){
              textVariables = $this.parents('.codeblock').find('code').html();
            }

            if ($this[0].className.includes("rating-scale")){
              textVariables = $this.parents('.codeblock').html();
            }

            if (textVariables.includes("<select")) {
              var selectString = textVariables.substring(textVariables.indexOf("<select"), textVariables.indexOf("</select>"))
              textVariables = textVariables.replace(selectString, self.state.if_select)
            }

            if (self.state.isFocused) {
              editor.insertContent(textVariables);
            } else {
              self.insertAtCaret(self.state.lastFocusedInput, textVariables, self.state.cursorPosition)
            }

            // ui cleanup
            $('.tooltip').hide();
            tinyMCE.activeEditor.windowManager.close(window);
            return false;
          });

          $(document.body).on('click', '.tag_tab', function (e) {
            if (self.state.active_tab != e.target.name) {
              self.setState({active_tab: e.target.name})
              tinyMCE.activeEditor.windowManager.close();
              mergeTagAction()
            }
          });

          $(document.body).on('change', '.if_select', function (e) {
            if (self.state.if_select != e.target.value) {
              self.setState({if_select: e.target.value})
            }
          });

          window.document.getElementsByClassName('merge-tabs')[0].style.cssText = "position: sticky; top: 0";
          window.document.getElementsByClassName('inactive')[0] ? window.document.getElementsByClassName('inactive')[0].parentElement.style.background = '#ffffff' : null
          window.document.getElementsByClassName('tox-dialog__body-content')[0].style.cssText = "max-height: 615px; padding: 0px";
          window.document.getElementsByClassName('tox-dialog__content-js')[0].style.cssText = "position: relative; top: 0px; height: 0px;";
          window.document.getElementsByClassName('body-content')[0].style.paddingLeft = '15px'
          window.document.getElementsByClassName('body-content')[0].style.paddingRight = '15px'
          window.document.getElementsByClassName('tox-dialog')[0].removeAttribute('tabIndex')
        },
        onSetup: function (buttonApi) {
          var editorEventCallback = function (eventApi) {
            buttonApi.setDisabled(eventApi.element.nodeName.toLowerCase() === 'time');
          };
          editor.on('NodeChange', editorEventCallback);
          return function (buttonApi) {
            editor.off('NodeChange', editorEventCallback);
          };
        }
      });

    }

  }

  getMaxImageTemplate() {
    var tmpl = '';
    tmpl += '<iframe allowfullscreen frameborder="0" id="ffg-iframe" height="100%" width="100%" src="' + this.props.images_data_table_path + '"></iframe>';
    return tmpl;
  }

  getMaxMergeTagTemplate() {
    var tmpl = '';
    tmpl += '<div class="merge-tabs">'
      tmpl += '<table class="table table-bordered">'
        tmpl += '<tr>'
          tmpl += '<th class="text-center"><a href="#merge_tags" name="merge_tags" class="' + (this.state.active_tab === 'merge_tags' ? 'active' : 'inactive') + ' tag_tab">' + (I18n.t('merge_tags')) + '</a></th>'
          tmpl += this.props.message ? '' : '<th class="text-center"><a href="#advanced" name="advanced" class="' + (this.state.active_tab === 'advanced' ? 'active' : 'inactive') + ' tag_tab">' + (I18n.t('advanced')) + '</a></th>'
        tmpl += '</tr>'
      tmpl += '</table>'
    tmpl += '</div>'

    tmpl += '<div class="body-content">'

      if (this.state.active_tab == "merge_tags") {

        // reservation merge tags
        tmpl += '<div class="reservation-email" style="display:' + (Cookies.get('help_type') == 'reservation' ? 'block' : 'none') + '">';
        tmpl += I18n.t('reservation_email_merge_tag_instructions');

        // reservation survey link tags
        tmpl += I18n.t('reservation_email_survey_links_instructions');
        if(this.props.survey_forms.length > 0) {
          tmpl += '<tr><td>{{#each rooms}}</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
          this.props.survey_forms.map((form) => {
            var title = "{{room.surveys." + form.title.split(" ").join('_').toLowerCase() + "}}";
            tmpl += '<tr><td>' + (title) + '</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
          })
          
          tmpl += '<tr><td>{{/each}} {{! Closes Rooms}}</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
  
        } else {
          tmpl += '<tr><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td></tr>';
        }
        tmpl += '</table>';
        // tmpl += '</div>';

        // reservation document link tags
        tmpl += I18n.t('reservation_email_agreement_links_instructions');
        if(this.props.agreement_forms.length > 0) {
          tmpl += '<tr><td>{{#each rooms}}</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
          this.props.agreement_forms.map((form) => {
            var title = "{{room.agreements." + form.title.split(" ").join('_').toLowerCase() + "}}";
            tmpl += '<tr><td>' + (title) + '</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
          })
          
          tmpl += '<tr><td>{{/each}} {{! Closes Rooms}}</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
  
        } else {
          tmpl += '<tr><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td></tr>';
        } 
        tmpl += '</table>';

        tmpl += '</div>';

        // room merge tags
        tmpl += '<div class="room-email" style="display:' + (Cookies.get('help_type') == 'room' ? 'block' : 'none') + '">';
        tmpl += I18n.t('room_email_merge_tag_instructions');

        //room survey link tags
        tmpl += I18n.t('room_email_survey_links_instructions');
        if(this.props.survey_forms.length > 0) {
          this.props.survey_forms.map((form) => {
            var title = "{{room.surveys." + form.title.split(" ").join('_').toLowerCase() + "}}";
            tmpl += '<tr><td>' + (title) + '</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
          })
        } else {
          tmpl += '<tr><td class="text-center" style="font-style: italic">' + I18n.t('none')  + '<span className="ss-help help" title="' + I18n.t('room_size_helper_text') + '"></span></td><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td></tr>';
        }
        tmpl += '</table>';
        // tmpl += '</div>';

        //room document link tags
        tmpl += I18n.t('room_email_agreement_links_instructions');
        if(this.props.agreement_forms.length > 0) {
          this.props.agreement_forms.map((form) => {
            var title = "{{room.agreements." + form.title.split(" ").join('_').toLowerCase() + "}}";
            tmpl += '<tr><td>' + (title) + '</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
          })
        } else {
          tmpl += '<tr><td class="text-center" style="font-style: italic">' + I18n.t('none')  + '<span className="ss-help help" title="' + I18n.t('room_size_helper_text') + '"></span></td><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td></tr>';
        }
        tmpl += '</table>';

        tmpl += '</div>';

        // campaign merge tags
        tmpl += '<div class="campaign-email" style="display:' + (Cookies.get('help_type') == 'campaign' ? 'block' : 'none') + '">';
        tmpl += I18n.t('campaign_email_merge_tag_instructions');
        tmpl += '</div>';

        // order merge tags
        tmpl += '<div class="order-email" style="display:' + (Cookies.get('help_type') == 'order' ? 'block' : 'none') + '">';
        tmpl += I18n.t('order_email_merge_tag_instructions');
        tmpl += '</div>';

        tmpl += '<div class="voucher-email" style="display:' + (Cookies.get('help_type') == 'voucher' ? 'block' : 'none') + '">';
        tmpl += I18n.t('voucher_email_merge_tag_instructions');
        tmpl += '</div>';

      } else {
        var if_options = this.props.folio_item_types.map((option) => {
          return `<option value=${I18n.t(option)}>${option}</option>`
        })
        var select = `<select class="if_select">${if_options}</select>`
        
        tmpl += '<div class="advanced">';
          tmpl += I18n.t('advanced_merge_tag_instructions', {select: select, survey: `room.surveys.${this.props.survey_forms[0]['title'].split(" ").join('_').toLowerCase()}`});
        tmpl += '</div>';
      }

    tmpl += '</div>';

    return tmpl;
  }

  getMaxMergeTagTitle() {
    return I18n.t(Cookies.get('help_type_name'))
  }

  // addSurveyLinksButton(editor) {
  //   var self = this;
  //   if (editor.ui) {
  //     editor.ui.registry.addButton('surveylinks', {
  //       icon: 'paste-column-after',
  //       tooltip: I18n.t('insert_survey_link'),
  //       disabled: false,
  //       onAction: function mergeTagAction(_) {
  //         tinymce.activeEditor.windowManager.open({
  //           title: I18n.t('survey_link_title'),
  //           body: {
  //             type: 'panel',
  //             items: [
  //               {
  //                 type: 'htmlpanel',
  //                 html: self.getSurveyLinksTemplate()
  //               }
  //             ]
  //           },
  //           buttons: [
  //             {
  //               type: 'cancel',
  //               text: 'OK'
  //             }
  //           ]
  //         });

  //         $(document.body).off(`click.mergetag`).on(`click.mergetag`, '.insert-merge-tag', function () {
  //           var $this = $(this);
  //           var textVariables = $this.parents('tr').find('td:first-child').html();
            
  //           if ($this[0].className.includes("example")){
  //             textVariables = $this.parents('.codeblock').find('code').html();
  //           }
  //           if (textVariables.includes("<select")) {
  //             var selectString = textVariables.substring(textVariables.indexOf("<select"), textVariables.indexOf("</select>"))
  //             textVariables = textVariables.replace(selectString, self.state.if_select)
  //           }

  //           if (self.state.isFocused) {
  //             editor.insertContent(textVariables);
  //           } else {
  //             self.insertAtCaret(self.state.lastFocusedInput, textVariables, self.state.cursorPosition)
  //           }

  //           // ui cleanup
  //           $('.tooltip').hide();
  //           tinyMCE.activeEditor.windowManager.close(window);
  //           return false;
  //         });

  //         $(document.body).on('change', '.if_select', function (e) {
  //           if (self.state.if_select != e.target.value) {
  //             self.setState({if_select: e.target.value})
  //           }
  //         });

  //         window.document.getElementsByClassName('tox-dialog__body-content')[0].style.cssText = "max-height: 615px; padding: 0px";
  //         window.document.getElementsByClassName('tox-dialog__content-js')[0].style.cssText = "position: relative; top: 0px; height: 0px;";
  //         window.document.getElementsByClassName('body-content')[0].style.paddingLeft = '15px'
  //         window.document.getElementsByClassName('body-content')[0].style.paddingRight = '15px'
  //         window.document.getElementsByClassName('tox-dialog')[0].removeAttribute('tabIndex')
  //       },
  //       onSetup: function (buttonApi) {
  //         var editorEventCallback = function (eventApi) {
  //           buttonApi.setDisabled(eventApi.element.nodeName.toLowerCase() === 'time');
  //         };
  //         editor.on('NodeChange', editorEventCallback);
  //         return function (buttonApi) {
  //           editor.off('NodeChange', editorEventCallback);
  //         };
  //       }
  //     });
  //   }
  // }

  // getSurveyLinksTemplate() {
  //   var tmpl = '';
  //   tmpl += '</br>'
  //   tmpl += '<div class="body-content">'
  //     // reservation merge tags
  //   if (Cookies.get('help_type') == 'reservation') {
  //     tmpl += '<div class="reservation-email" style="display:' + (Cookies.get('help_type') == 'reservation' ? 'block' : 'none') + '">';
  //     tmpl += I18n.t('reservation_email_survey_links_instructions');
  //     if(this.props.survey_forms.length > 0) {
  //       this.props.survey_forms.map((form) => {
  //         var title = "{{room.surveys." + form.title.split(" ").join('_').toLowerCase() + "}}";
  //         tmpl += '<tr><td>' + (title) + '</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
  //       })
  //       tmpl += '<tr><td>{{/each}} {{! Closes Rooms}}</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
  
  //       tmpl += '</table>';
  //       tmpl += '</div>';

  //     } else {
  //       tmpl += '<tr><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td></tr>';
  //     } 
  //   } else {
  //     tmpl += '<div class="room-email" style="display:' + (Cookies.get('help_type') != 'room' ? 'block' : 'none') + '">';
  //     tmpl += I18n.t('room_email_survey_links_instructions');
  //     if(this.props.survey_forms.length > 0) {
  //       this.props.survey_forms.map((form) => {
  //         var title = "{{room.surveys." + form.title.split(" ").join('_').toLowerCase() + "}}";
  //         tmpl += '<tr><td>' + (title) + '</td><td class="text-center"><span class="ss-navigatedown insert-merge-tag">&nbsp;</span></td></tr>';
  //       })
  //     } else {
  //       tmpl += '<tr><td class="text-center" style="font-style: italic">' + I18n.t('none')  + '<span className="ss-help help" title="' + I18n.t('room_size_helper_text') + '"></span></td><td class="text-center" style="font-style: italic">' + I18n.t('none') + '</td></tr>';
  //     }
  //   }

  //   tmpl += '</table>';
  //   tmpl += '</div>';

  //   return tmpl;
  // }

  getCursorPosition(element) {
    var el = $(element).get(0);
    var pos = 0;
    if ('selectionStart' in el) {
      pos = el.selectionStart;
    } else if ('selection' in document) {
      el.focus();
      var Sel = document.selection.createRange();
      var SelLength = document.selection.createRange().text.length;
      Sel.moveStart('character', -el.value.length);
      pos = Sel.text.length - SelLength;
    }
    return pos;
  }

  insertAtCaret(element, text, strPos) {
    ('insertAtCaret!', element, text, strPos);
    var txtarea = element;
    if (!txtarea) {
      return;
    }
    var scrollPos = txtarea.scrollTop;
    var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
      "ff" : (document.selection ? "ie" : false));
    var front = (txtarea.value).substring(0, strPos);
    var back = (txtarea.value).substring(strPos, txtarea.value.length);
    var name = (txtarea.name).substring(6, (txtarea.name).length - 1)
    txtarea.value = front + text + back;
    EmailBuilderActions.setEmail(name, txtarea.value);
    
    if (this.props.setMessageTo && text) {
      MessageBuilderActions.setValue('to', text);
    }

    strPos = strPos + text.length;
    if (br == "ie") {
      txtarea.focus();
      var ieRange = document.selection.createRange();
      ieRange.moveStart('character', -txtarea.value.length);
      ieRange.moveStart('character', strPos);
      ieRange.moveEnd('character', 0);
      ieRange.select();
    } else if (br == "ff") {
      txtarea.selectionStart = strPos;
      txtarea.selectionEnd = strPos;
      txtarea.focus();
    }
    txtarea.scrollTop = scrollPos;
  }
}

export default RichTextEditor
